import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ContentService, ContentItem } from '@awp/content';
import { AppConfig } from '@awp/core/config';
import { isNullOrEmpty } from '@awp/core/utils';

export interface LinkProperty {
  href: string;
}

export interface HalResponse {
  clientName: string;
  _links: { [key: string]: LinkProperty };
  _embedded: { [key: string]: any };
  [key: string]: string | ContentItem | LinkProperty | any;
}

@Injectable()
export class CmsContentHalService implements ContentService {

  private _clientName: string;
  private _rootConfig: { rootUrl: string, themeUrl: string };

  constructor(private httpClient: HttpClient, private injector: Injector) { }

  public getContent(url: 'root' | string, lang?: string, responseType: string = 'json'): Observable<any> {
    const fetchUrl = url === 'root' ? this.getRootUrl() : url;
    return responseType === 'html'
      ? this.fetchBlobContent(fetchUrl, 'text')
      : this.fetchJsonContent(fetchUrl);
  }

  setClient(clientName: string): void {
    if (this._clientName !== clientName) {
      this._clientName = clientName;
    }
  }

  private getUrl(): { rootUrl: string, themeUrl: string } {
    if (this._rootConfig == null) {
      const appConfig = this.injector.get(AppConfig);
      this._rootConfig = {
          rootUrl: appConfig.CMS_ROOT_API_URL,
          themeUrl: appConfig.CMS_THEME_API_URL
        };
    }

    return this._rootConfig;
  }

  private getRootUrl(): string {
    return isNullOrEmpty(this._clientName)
      ? this.getUrl().rootUrl
      : `${this.getUrl().themeUrl}/${this._clientName}`;
  }

  private fetchJsonContent<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(url);
  }

  private fetchBlobContent(url: string, responseType: 'text'): Observable<string> {
    return this.httpClient.request('GET', url, { responseType });
  }

}